import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { 
  initializeFirestore, 
  persistentLocalCache, 
  persistentMultipleTabManager 
} from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyCBRresZ5mOW3z7EW7PRvRVDjO6FKcUJTU",
  authDomain: "www.sitewisepro.co.za",
  projectId: "construction-app-41678",
  storageBucket: "construction-app-41678.firebasestorage.app",
  messagingSenderId: "665726765532",
  appId: "1:665726765532:web:1c5565df0858d3fde1a719",
  measurementId: "G-5EXSWT96RE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore with Persistent Cache (Offline Support)
// This replaces the standard getFirestore(app)
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});

// Export other services
export const auth = getAuth(app);

export const storage = getStorage(app);

export default app;